var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rank-wrapper pa-2"},[_c('h3',{staticClass:"body-2 font-weight-black"},[_vm._v(_vm._s(_vm.value))]),_c('h6',{staticClass:"rank-label grey--text"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }